import React from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { appDocumentTitle } from '../../appMeta';
import { useAuth } from '../../auth/AuthContext';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { PageShell } from '../../layout/PageShell';
import { useNavigationMenuQuery } from '../../query/hooks';
import { canAccessSamplingSchedulesPage } from '../QuotationsPage/quotationWorkflow';
import { SamplingSchedulesListTabScreen } from './TabScreens/List';

export function SamplingSchedulesPage() {
  const { jwt, user } = useAuth();
  const menuQ = useNavigationMenuQuery(jwt);
  const canView = canAccessSamplingSchedulesPage(user, menuQ.data?.access_codes);

  useDocumentTitle(appDocumentTitle('Penjadwalan Sampling'));

  if (menuQ.isPending) {
    return (
      <Box display="flex" justifyContent="center" py={4}>
        <CircularProgress size={32} />
      </Box>
    );
  }

  if (menuQ.isError) {
    return (
      <Alert severity="error">
        {menuQ.error instanceof Error ? menuQ.error.message : 'Gagal memuat menu permission.'}
      </Alert>
    );
  }

  if (!canView) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <PageShell title="Penjadwalan Sampling" subtitle="Daftar dan kalender penjadwalan sampling.">
      <SamplingSchedulesListTabScreen />
    </PageShell>
  );
}

export { SamplingScheduleDetailRoute } from './SamplingScheduleDetailRoute';
